export const shortenName = (name: string, chars = 24): string => {
  const cutoff: number = Math.min(chars, name.length);
  const shortenedName: string = name.slice(0, cutoff);
  const nameChars: string[] = shortenedName.split("");

  if (name.length > chars) {
    nameChars.push("...");
  }

  return nameChars.join("");
};
